<template>
    <b-modal
        v-model="modal.state"
        @hidden="hideModal"
        modal-class="contact-modal"
        centered
        size="lg"
        hide-footer
        no-close-on-esc
        no-close-on-backdrop
    >
        <template v-slot:modal-header="{ close }">
            <div class="modal-title centered">
                <h1 class="title">
                    Let's Discuss
                </h1>
                <p class="sub-title mb-0">
                    I'll help you understand how to secure the home you really want, then confidently sell your
                    existing home.
                </p>
            </div>
            <b-button
                variant="link"
                class="close"
                @click="close"
            >
                <i class="far fa-times" />
            </b-button>
        </template>
        <b-form
            @submit.prevent="handleSubmit"
        >
            <b-form-row class="inline">
                <b-col
                    sm="6"
                    class="first"
                >
                    <b-form-group
                        label="First Name"
                        label-class="font-weight-bold pb-0"
                    >
                        <b-form-input
                            :state="formErrors.firstName ? false : null"
                            type="text"
                            :disabled="loading"
                            v-model="form.firstName"
                        />
                        <template v-if="formErrors.firstName">
                            <b-form-invalid-feedback
                                :key="errIndex"
                                class="d-block"
                                v-for="(error, errIndex) in formErrors.firstName"
                            >
                                <i class="fal fa-exclamation-circle w-auto" />
                                {{ error.replace('!', '') }}
                            </b-form-invalid-feedback>
                        </template>
                    </b-form-group>
                </b-col>
                <b-col
                    sm="6"
                    class="last"
                >
                    <b-form-group
                        label="Last Name"
                        label-class="font-weight-bold pb-0"
                    >
                        <b-form-input
                            :state="formErrors.lastName ? false : null"
                            type="text"
                            :disabled="loading"
                            v-model="form.lastName"
                        />
                        <template v-if="formErrors.lastName">
                            <b-form-invalid-feedback
                                :key="errIndex"
                                class="d-block"
                                v-for="(error, errIndex) in formErrors.lastName"
                            >
                                <i class="fal fa-exclamation-circle w-auto" />
                                {{ error.replace('!', '') }}
                            </b-form-invalid-feedback>
                        </template>
                    </b-form-group>
                </b-col>
            </b-form-row>
            <b-form-row class="inline">
                <b-col
sm="6"
class="first"
>
                    <b-form-group
                        label="Email"
                        label-class="font-weight-bold pb-0"
                    >
                        <b-form-input
                            :state="formErrors.email ? false : null"
                            type="text"
                            :disabled="loading"
                            v-model="form.email"
                        />
                        <template v-if="formErrors.email">
                            <b-form-invalid-feedback
                                :key="errIndex"
                                class="d-block"
                                v-for="(error, errIndex) in formErrors.email"
                            >
                                <i class="fal fa-exclamation-circle w-auto" />
                                {{ error.replace('!', '') }}
                            </b-form-invalid-feedback>
                        </template>
                    </b-form-group>
                </b-col>
                <b-col
sm="6"
class="last"
>
                    <b-form-group
                        label="Phone"
                        label-class="font-weight-bold pb-0"
                        class="number"
                    >
                        <b-form-input
                            :state="formErrors.phone ? false : null"
                            :disabled="loading"
                            v-model="phone"
                            placeholder="(   )    -    "
                            :formatter="formatNumber"
                        />
                        <template v-if="formErrors.phone">
                            <b-form-invalid-feedback
                                :key="errIndex"
                                class="d-block"
                                v-for="(error, errIndex) in formErrors.phone"
                            >
                                <i class="fal fa-exclamation-circle w-auto" />
                                {{ error.replace('!', '') }}
                            </b-form-invalid-feedback>
                        </template>
                    </b-form-group>
                </b-col>
            </b-form-row>
            <b-form-group
                label="Home Address — optional"
                label-class="font-weight-bold pb-0"
            >
                <b-form-input
                    type="text"
                    :disabled="loading"
                    v-model="form.homeAddress"
                />
                <FormErrors
                    :errors="formErrors"
                    field="homeAddress"
                />
            </b-form-group>
            <b-form-group
                label="Desired Sale Price — optional"
                label-class="font-weight-bold pb-0"
                class="price number"
            >
                <b-input-group>
                    <b-input-group-prepend>
                      <span
                          class="input-group-text-coherent"
                      >
                        <i class="far fa-dollar-sign" />
                      </span>
                    </b-input-group-prepend>
                    <b-form-input
                        :disabled="loading"
                        v-model="price"
                        class="form-control-coherent"
                        :formatter="formatPrice"
                    />
                    <template v-if="formErrors.desiredSalePrice">
                        <b-form-invalid-feedback
                            :key="errIndex"
                            class="d-block"
                            v-for="(error, errIndex) in formErrors.desiredSalePrice"
                        >
                            <i class="fal fa-exclamation-circle w-auto" />
                            {{ error.replace('!', '') }}
                        </b-form-invalid-feedback>
                    </template>
                </b-input-group>
            </b-form-group>

            <b-form-group
                label="Message"
                label-class="font-weight-bold pb-0"
            >
                <b-form-textarea
                    :disabled="loading"
                    rows="4"
                    v-model="form.message"
                />
                <FormErrors
                    :errors="formErrors"
                    field="message"
                />
            </b-form-group>
            <b-form-group class="mb-0">
                <b-button
                    :disabled="loading"
                    type="submit"
                    variant="primary"
                    block
                    size="lg"
                >
                    <b-spinner v-if="loading" />
                    Contact Me
                </b-button>
            </b-form-group>
        </b-form>
    </b-modal>
</template>

<script>
import './ContactModal.scss';
import './ContactModal.mobile.scss';
import FormErrorsMixin from "@milestoneslabs/milestones-ui-kit/src/components/FormErrors/FormErrorsMixin";
import cloneDeep from 'lodash/cloneDeep';
import axios from 'axios';
import ShowNotificationMixin from "@milestoneslabs/milestones-ui-kit/src/mixins/ShowNotificationMixin";
import parsePhoneNumber from 'libphonenumber-js';
import get from "lodash/get";
import find from "lodash/find";

export const CONTACT_MODAL_OPEN = 'CONTACT_MODAL_OPEN';
const FORM = {
    firstName: '',
    lastName: '',
    email: '',
    phone: '',
    homeAddress: '',
    desiredSalePrice: null,
    message: 'I\'d like to learn more about a trade-in, so that I can get my next home, move in, and then sell my ' +
        'current home for full market value.',
    landingPageUuid: window.landingPageUuid
};
export default {
    name: "ContactModal",
    mixins: [FormErrorsMixin, ShowNotificationMixin],
    data() {
        return {
            modal: {
                state: false,
            },
            loading: false,
            form: cloneDeep(FORM),
            phone: '',
            price: '',
        };
    },
    computed: {
        validationRules() {
            return {
                firstName: {
                    type: 'string',
                    presence: true,
                    length: {
                        minimum: 1,
                        maximum: 255,
                        tooShort: 'is required!'
                    }
                },
                lastName: {
                    type: 'string',
                    presence: true,
                    length: {
                        minimum: 1,
                        maximum: 255,
                        tooShort: 'is required!'
                    }
                },
                email: {
                    type: 'string',
                    presence: true,
                    email: true,
                },
                phone: {
                    phoneNumber: {
                        country: 'US',
                        presence: true,
                    },
                },
                homeAddress: {
                    type: 'string',
                    length: {
                        maximum: 255,
                    }
                },
                desiredSalePrice: {
                    numericality: true
                },
                message: {
                    type: 'string',
                    length: {
                        maximum: 30000,
                    }
                },
            };
        }
    },
    methods: {
        async handleSubmit() {
            if (this.phone) {
                let phoneNumber = parsePhoneNumber(this.phone, 'US');
                this.form.phone = phoneNumber.number;
            }
            if (this.price) {
                this.form.desiredSalePrice = parseInt(this.price.toString().replace(/,/g, ''));
            }

            const errors = this.$validate(this.form, this.validationRules);
            if (this.form.desiredSalePrice > 99999999999) {
                errors.desiredSalePrice = ['Desired sale price is too big'];
            }

            this.setformErrors(errors);

            if (errors) {
                return;
            }

            this.loading = true;
            try {
                await axios.post(`${window.env.MILESTONES_AUTH_HOST}/public-api/v1/landings/pages/contact`,
                                 this.form,
                );
                this.hideModal();
                this.phone = '';
                this.price = '';
                this.showNotification({
                    message: `Message Sent`,
                    type: 'success',
                });
            } catch (e) {
                console.warn(e);
                let errors = get(e, 'response.data.errors');
                let message = `There was an error! Please try again later.`;

                if (errors && Array.isArray(find(errors)) && find(errors).length) {
                    message = find(errors)[0];
                }

                this.showNotification({
                    message: message,
                    type: 'error',
                });
            } finally {
                this.loading = false;
            }
        },
        onContactModalOpen() {
            this.modal.state = true;
        },
        hideModal() {
            this.modal.state = false;
            this.form = cloneDeep(FORM);
            this.phone = '';
            this.price = '';
            this.setformErrors({});
        },

        formatNumber(value) {
            var x = value.replace(/\D/g, '').match(/(\d{0,3})(\d{0,3})(\d{0,4})/);
            value = !x[2] ? x[1] : '(' + x[1] + ') ' + x[2] + (x[3] ? '-' + x[3] : '');

            return value;
        },

        formatPrice(value) {
            return value
                .replace(/\D/g, "")
                .replace(/\B(?=(\d{3})+(?!\d))/g, ",");
        }
    },
    async beforeMount() {
        this.$bus.$on(CONTACT_MODAL_OPEN, this.onContactModalOpen);
    },
    beforeDestroy() {
        this.$bus.$off(CONTACT_MODAL_OPEN, this.onContactModalOpen);
    }
};
</script>
